import { ref } from 'vue';

/**
 * Composable para estado de ordenação de coluna (qual coluna e direção asc/desc).
 * Útil para tabelas com ordenação por clique no header.
 * @param {string|null} initialKey - Chave inicial da coluna ordenada
 * @param {'asc'|'desc'} initialOrder - Ordem inicial
 * @returns {{ sortKey: Ref, sortOrder: Ref, toggleOrdenacao: (key: string) => void }}
 */
export function useOrdenacaoColuna(initialKey = null, initialOrder = 'asc') {
  const sortKey = ref(initialKey);
  const sortOrder = ref(initialOrder);

  function toggleOrdenacao(key) {
    if (sortKey.value === key) {
      sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
    } else {
      sortKey.value = key;
      sortOrder.value = 'asc';
    }
  }

  return { sortKey, sortOrder, toggleOrdenacao };
}
